// --------------------------------------------------------------
// Created On: 2025-11-05
// Author: Marco Serrano
//
// Last Modified: 2025-11-05
// Modified By: Marco Serrano
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Get the selected paint color id.
export default function getPaintColorId(paintColors: PaintColor[], selectedPaintColorId: number | null): number | null {
  const paintColorIndex = paintColors.findIndex((paintColor) => paintColor.paintColorId === selectedPaintColorId);
  if (paintColorIndex > -1) {
    return paintColors[paintColorIndex].paintColorId;
  }
  return null;
}

interface PaintColor {
  paintColorId: number;
  hexCode: string;
  name: string;
}
